// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiDelete } from "@mdi/js";

import { ShapefileAction } from "../..";
import { useSelectedProjectPermissions } from "../../../../../../projects/hooks";
import { useDeleteShapefileList } from "../../../../../../shapefiles/hooks/delete-shapefile-list/useDeleteShapefileList";
import { ACTION_TEXT } from "../../constants/actionText.constants";

interface IShapefileFolderDeleteSelectedItemsActionProps {
  onContextMenuClose?: () => void;
  actionText?: string;
}

/**
 * Delete Selected Items action for shapefile folders.
 *
 * NOTE: This action is currently only implemented for the Project tree.
 * If desired for Organization/System trees, the action will need to be refactored
 * in ShapefileActions/ShapefileFolderActions to be passed in as a prop if there
 * are differences between trees, similar to the rest of the actions.
 */
export function ShapefileFolderDeleteSelectedItemsAction({
  onContextMenuClose,
  actionText = ACTION_TEXT.DELETE_SELECTED_ITEMS
}: IShapefileFolderDeleteSelectedItemsActionProps) {
  const deleteShapefileModal = useDeleteShapefileList();
  const selectedProjectPermissions = useSelectedProjectPermissions();

  // Don't render if not in manage mode or user doesn't have permissions
  if (
    !deleteShapefileModal.manageLayerTree.isManageMode ||
    !selectedProjectPermissions?.canEditProjectItems
  ) {
    return null;
  }

  const isDisabled = deleteShapefileModal.manageLayerTree.checkedKeys.length === 0;
  return (
    <ShapefileAction
      disabled={isDisabled}
      danger
      onClick={(evt) => {
        deleteShapefileModal.handleModalOpen();
        if (onContextMenuClose) onContextMenuClose();
        evt.stopPropagation();
        evt.preventDefault();
      }}>
      <Icon path={mdiDelete} size={1} />
      {actionText}
    </ShapefileAction>
  );
}
